enum AuthRequestStatus {
    none = 'NO_REQUEST',
    /* State while app is verifying if user has valid auth from previous "session" */
    verify = 'ACTIVE_VERIFY_REQUEST',
    /* State when app has received an error after verifying is user has valid auth from previous "session" */
    await = 'AWAIT_REQUEST_AUTH',
    active = 'ACTIVE_REQUEST',
    authSuccess = 'REQUEST_AUTH_SUCCESS',
    configSuccess = 'REQUEST_CONFIG_SUCCESS',
    error = 'REQUEST_ERROR',
}

export default AuthRequestStatus;
